import { Config } from "@app/config";
import { http } from "@shared/ui";
import type { PensionLeadCalcResponse } from "../LeadForm/types";
import type { FormFields } from "./PensionSavingsSmallCalculator";

interface CalcRequest {
	birthYear: number;
	monthlyPayment: number;
}

export function getSearchData(values: FormFields): CalcRequest {
	const { monthlyDeposit, birthYear } = values;

	return {
		birthYear,
		monthlyPayment: monthlyDeposit,
	};
}

export function calculate(values: FormFields): Promise<PensionLeadCalcResponse> {
	const calcRequest: CalcRequest = getSearchData(values);

	return http.get(Config.getApiUrl("/api/public/pension/calculate", { annualIncrease: false, ...calcRequest }));
}
